import React, { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

function ReprosesJurnal() {
  const {periodeakun, bulan, api } = useGlobalContext();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const year = periodeakun.substring(0, 4);
  const month = parseInt(periodeakun.substring(4, 6), 10);

  let prevMonth = month - 1;
  let prevTahun = year;

  if (prevMonth <= 0) {
    prevMonth = 12;
    prevTahun = (parseInt(year, 10) - 1).toString();
  }

  const prevPeriode = `${prevTahun}${String(prevMonth).padStart(2, "0")}`;

  const currentPeriodeDisplay = `${bulan[month - 1]} ${year}`;

  const GetRekeningPerkiraan = async (filterperiode) => {
     try {
       const response = await api.get(`/api/akuntansi/rekeningperkiraan/${filterperiode}/`);
       return response.data || [];
     } catch (error) {
       console.error("Error fetching rekening perkiraan:", error);
        return [];
     }
   };

  const GetJurnalHarianByPeriode = async () => {
    try {
      const response = await api.get(`/api/akuntansi/jurnalharianbyperiode/${periodeakun}`);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching jurnal harian by periode:", error);
      return [];
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("Sedang memproses data...");

    const dataRekPerkiraanbefore = await GetRekeningPerkiraan(prevPeriode);
    const dataRekPerkiraan = await GetRekeningPerkiraan(periodeakun);
    const dataJurnalHarianByPeriode = await GetJurnalHarianByPeriode();

    if (!Array.isArray(dataRekPerkiraanbefore) || dataRekPerkiraanbefore.length === 0) {
      setMessage(" Data rekening perkiraan bulan sebelumnya tidak ditemukan!");
      console.error("Data rekening perkiraan sebelumnya kosong");
      return;
    }

    if (!Array.isArray(dataRekPerkiraan) || dataRekPerkiraan.length === 0) {
      setMessage(" Data rekening perkiraan periode saat ini tidak ditemukan!");
      console.error("Data rekening perkiraan kosong");
      return;
    }

    if (!Array.isArray(dataJurnalHarianByPeriode) || dataJurnalHarianByPeriode.length === 0) {
      setMessage(" Data jurnal harian tidak ditemukan!");
      console.error("Data jurnal harian kosong");
      return;
    }

    const dataupdate = dataRekPerkiraan.map(item => {
      const mutasi_th = dataRekPerkiraanbefore.find(m=> m.kdperk === item.kdperk);
      return {
        periode: periodeakun,       
        kdperk : item.kdperk,
        awaldb : item.awaldb,  
        awalkd : item.awalkd,
        mutdbth: month===1 ? 0 : mutasi_th?.mutdbth || 0 ,
        mutkdth: month===1 ? 0 : mutasi_th?.mutkdth || 0 ,
        saldoth: mutasi_th?.saldoth || 0 
      }
    });

    const jurnalMap = dataJurnalHarianByPeriode.map(item => ({
      periode: periodeakun,
      kdperk: item.kdperk,
      posisi : item.posisi,
      penbia: item.penbia,
      debet: item.debet || 0,
      kredit: item.kredit || 0
    }));

    console.log("Data Jurnal Harian:", dataJurnalHarianByPeriode);
    console.log("Jurnal Map:", jurnalMap);

    const recordsToUpdate = dataupdate.map((item) =>
      api.patch(`/api/akuntansi/rekeningperkiraanreset`, item )
    );

    const jurnalToUpdate = jurnalMap.map((item) =>
      api.patch(`/api/akuntansi/mutasirekperkiraan`, item)
    );

    const resultsRek = await Promise.all(recordsToUpdate);
    console.log("Update rekening perkiraan selesai:", resultsRek.length, "records");
    
    const resultsJurnal = await Promise.all(jurnalToUpdate);
    console.log("Update mutasi rekening perkiraan selesai:", resultsJurnal.length, "records");
    
    setMessage("Reproses jurnal selesai!");
    //setLoading(false);
    
    setTimeout(() => {        
      localStorage.removeItem('pengguna'); 
      window.location.href = '/login'; 
    }, 3000);
    
  }
  

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card card-info" style={{ width: "400px" }}>
        <div className="card-header text-center">
          <h5 className="card-title">Reproses</h5>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Periode</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={currentPeriodeDisplay} readOnly />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Memproses...' : 'Proses'}
          </button>
          {message && (
            <div className="alert alert-info mt-4 text-center" role="alert">{message}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReprosesJurnal;
